"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const displayWrapper_1 = require("./common/displayWrapper");
const hooks_1 = require("common/hooks");
const isValidElement = (obj) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _obj = obj;
    return _obj && _obj.type && typeof _obj.type === "string";
};
const applyValue = (func, value) => {
    const s = (0, hooks_1.useStringIntl)();
    if (typeof func === "function") {
        return func({ value });
    }
    else if (isValidElement(func)) {
        return func;
    }
    else if (typeof func === "number") {
        return func;
    }
    else {
        return s(func);
    }
};
const MessageSchemaComponent = (props) => {
    const { schema } = props;
    const { text } = schema;
    const value = (0, core_1.useValue)(props);
    return react_1.default.createElement(react_1.default.Fragment, null, applyValue(text, value));
};
MessageSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MessageDisplayComponent", (value, schema) => {
    const { text } = schema;
    return applyValue(text, value);
});
exports.default = MessageSchemaComponent;
